import Vue from 'vue'
import Router from 'vue-router'
import Quotation from '@/components/quotation/Quotation'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/quotation',
      name: 'Anfrage - Neu',
      component: Quotation
    },
    {
      path: '/quotation',
      name: 'Anfrage - Neu',
      component: Quotation
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js